import { useState ,useRef } from "react";
import axios from "axios";
import { useEffect } from "react";
import barcodeHelp from "./barcodeHelp.png";
import {toast} from "react-toastify";


export default function AdvanceSetting({ isLog }) {
  // const [isActiveLog, setisActiveLog] = useState(isLog);
  // const [isActiveBackup, setisActiveBackup] = useState(isLog);
  
  const textUnderIndexRef = useRef();
  const textUnderBillsRef = useRef();
  const textUnderCustomerBillRef = useRef();
  const barcodeCountRef = useRef();
  const barcodeWidthRef = useRef();
  const barcodeLengthRef = useRef();
  const paperWidthRef = useRef();
  const productFontRef = useRef();
  const priceFontRef = useRef();
  const productCodeRef = useRef();
  const priceCheckBoxRef = useRef();
  const colorCheckBoxRef = useRef();
  const sizeCheckBoxRef = useRef();
  const monetaryUnit = useRef();
  const triggerToShopRef = useRef();

  useEffect(() => {
    axios
      .get(`${localStorage.getItem("apiUrl")}/settings/`, {
        params: { settingName: "advanced" },
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(({ data }) => {
        let form = formRef.current;
        for (let key in data.print) {
          form[key].value = data.print[key];
        }
            for (let key in data.currency) {
          form[key].value = data.currency[key];
        }
        for (let key in data.barcode) {
          if(form[key].value==="on"){
            form[key].checked=data.barcode[key]
          }
          form[key].value = data.barcode[key];
          
        }
        for (let key in data.trigger) {
          if(form[key].value==="on"){
            form[key].checked=data.trigger[key]
          }
          form[key].value = data.trigger[key];
        }

        // for(let x in data){
        //   for (let key in x){
        //     if(form[key].value==="on"){
        //           form[key].checked=x[key]
        //         }
        //     form[key].value=x[key]
        //   }

        // }
      });
    
  }, []);
  const formRef=useRef(null)

  function submitAdvanceSetting(e) {
    e.preventDefault();
    let form = e.target;

    let formData = { print: [], barcode: [], currency: [], trigger:[] };

    console.log(form.elements);
    // push Print Texts
    formData['print'].push({name: "text4",value: textUnderIndexRef.current.value});
    formData['print'].push({name: "text5",value: textUnderBillsRef.current.value});
    formData['print'].push({name: "text6",value: textUnderCustomerBillRef.current.value});
    // push barCode Data
    formData['barcode'].push({name: "barcodeCount",value: barcodeCountRef.current.value});
    formData['barcode'].push({name: "barcodeWidth",value: barcodeWidthRef.current.value});
    formData['barcode'].push({name: "barcodeLength",value: barcodeLengthRef.current.value});
    formData['barcode'].push({name: "paperWidth",value: paperWidthRef.current.value});
    formData['barcode'].push({name: "productFont",value: productFontRef.current.value});
    formData['barcode'].push({name: "priceFont",value: priceFontRef.current.value});
    formData['barcode'].push({name: "productCode",value: productCodeRef.current.checked===true ? 1 : 0});
    formData['barcode'].push({name: "productPrice",value: priceCheckBoxRef.current.checked===true ? 1 : 0});
    formData['barcode'].push({name: "productColor",value: colorCheckBoxRef.current.checked===true ? 1 : 0});
    formData['barcode'].push({name: "productSize",value: sizeCheckBoxRef.current.checked===true ? 1 : 0});
    formData['currency'].push({name: "STR1",value: monetaryUnit.current.value});
    // push trigger
    formData['trigger'].push({name: "trigger",value: triggerToShopRef.current.checked});


    // for (let i = 0; i < form.elements.length; i++) {
    //   console.log( "first of Form" + i);
    //   let key = "";
    //   switch (true) {
    //     case i < 3:
    //       key = "print";
    //       break;
    //     case i >= 3 && i < 12:
    //       key = "barcode";
    //       // if (i === 3) {
    //       //   form.elements[i].name = form.elements[i].checked
    //       //     ? "STR1"
    //       //     : "AliTaheri";
    //       //   form.elements[i].value = form.elements[i].checked
    //       //     ? form.elements[4].checked &&
    //       //       "" &&
    //       //       form.elements[5].checked &&
    //       //       form.elements[6].value
    //       //     : "AliTaheri";
    //       // }
    //       break;
    //     case i === 12:
    //       key = "currency";
    //       break;
    //     case i === 13:
    //       key = "trigger";
    //       break;
    //     default:
    //       console.warn("Data inserting error");
    //       break;
    //   }
    //   if ( i !== 14) {
    //     console.log( "in The If: " + i);
    //     console.log( "key Is : " + key);
    //     if (i === 8||i===9||i===10||i===11|| i===13) {
    //          var value = form.elements[i].checked
    //          if(value===true){
    //             value = 1
    //          }
    //          else{
    //            value = 0
    //          }
    //     }
    //     else{
    //     value= form.elements[i].value;
    //     }
    //
    //     formData[key].push({
    //       name: form.elements[i].name,
    //       value: value,
    //     });
    //     console.log(formData);
    //   }
    // }


    axios({
      method: "post",
      url: `${localStorage.getItem("apiUrl")}/settings/`,
      params: { settingName: "advanced" },
      data: formData,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response)=>{
      toast.success("اطلاعات ثبت شد.")
    });
  }

  return (
    <form ref={formRef} onSubmit={submitAdvanceSetting} className="advanceSet">
      <h5>
        <i className="fa fa-print ms-1"></i> پاورقی های چاپ
      </h5>
      <div className="row">
        <div className="col-md-8 mx-auto">
          <div className="form-group">
            <label>متن پایین چاپ فهرست ها</label>
            <textarea
              ref={textUnderIndexRef}
              name="text4"
              className="form-control"
              rows={1}
              defaultValue={""}
            />
          </div>
          <div className="form-group">
            <label>متن پایین فاکتورها</label>
            <textarea
              ref={textUnderBillsRef}
              name="text5"
              className="form-control"
              rows={1}
              defaultValue={""}
            />
          </div>
          <div className="form-group">
            <label>متن زیر صورتحساب مشتری</label>
            <textarea
              ref={textUnderCustomerBillRef}
              name="text6"
              className="form-control"
              rows={1}
              defaultValue={""}
            />
          </div>
        </div>
      </div>

      <h5>
        <i className="fa fa-barcode ms-1"></i>تنظیمات بارکد
      </h5>
      <div className="row mb-4">
        <div className="col-md-4 ">
          <div className="form-group">
            <label>تعداد بارکد </label>
            <select ref={barcodeCountRef} className="form-control" name="barcodeCount">
              <option>1</option>
              <option>2</option>
              <option>3</option>
            </select>
          </div>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-md-4 mx-auto">
          <div className="form-group">
            <label>طول بارکد (mm)</label>
            <input ref={barcodeWidthRef} type="text" name="barcodeWidth"/> {/*  طول و عرض درست شد اینجا  نام رو توی کامیت قبلی عوض کردم*/}
          </div>
        </div>
        <div className="col-md-4 mx-auto">
          <div className="form-group">
            <label>عرض بارکد (mm)</label>
            <input ref={barcodeLengthRef} type="text" name="barcodeLength"/>
          </div>
        </div>
     
        <div className="col-md-4 mx-auto">
          <div className="form-group">
            <label>طول کاغذ (mm)</label>
            <input ref={paperWidthRef} type="text" name="paperWidth"/>
          </div>
        </div> 
        <div className="col-md-4 mx-auto">
          <div className="form-group">
            <label>اندازه فونت نام کالا(px)</label>
            <input ref={productFontRef} type="text" name="productFont"/>
          </div>
        </div>
        <div className="col-md-4 mx-auto">
          <div className="form-group">
            <label>اندازه فونت قیمت(px)</label>
            <input ref={priceFontRef} type="text" name="priceFont"/>
          </div>
        </div>
        <div className="col-md-4 mx-auto">

        </div>
      </div>
      <div className="row mb-4">
        <div className="col-md-4 mx-auto">
          <img src={barcodeHelp} />
        </div>
      </div>
      <h6 className="mb-4">چه مشخصاتی در بارکد چاپ شود</h6>
      <div className="row">
        <div className="col-md-3">  <div className="form-group">
        <div className="form-check">
          <input ref={productCodeRef} id={"productCode"} type="checkbox" className="form-check-input" name="productCode"/>
          <label htmlFor={"productCode"} className="form-check-label mr-3">کد کالا</label>
        </div>
      </div></div>
        <div className="col-md-3"> <div className="form-group">
        <div className="form-check">
          <input ref={priceCheckBoxRef}  id={"priceCheckBox"} type="checkbox" className="form-check-input" name="productPrice" />
          <label htmlFor={"priceCheckBox"} className="form-check-label mr-3">قیمت</label>
        </div>
      </div></div>
        <div className="col-md-3"><div className="form-group">
        <div className="form-check">
          <input ref={colorCheckBoxRef} id={"colorCheckBoxRef"} type="checkbox" className="form-check-input" name="productColor" />
          <label htmlFor={"colorCheckBoxRef"} className="form-check-label mr-3">رنگ</label>
        </div>
      </div></div>
        <div className="col-md-3"><div className="form-group">
        <div className="form-check">
          <input ref={sizeCheckBoxRef}  id={"sizeCheckBox"} type="checkbox" className="form-check-input" name="productSize" />
          <label htmlFor={"sizeCheckBox"} className="form-check-label mr-3">سایز</label>
        </div>
      </div></div>
      </div>
    
     
      
      
      <h5>
        <i className="fa fa-money-bill ms-1"></i>واحد پولی
      </h5>
      <div className="row">
        <div className="col-md-6 mx-auto">
          <div className="form-group">
            <label>واحد پولی</label>
            <select ref={monetaryUnit} className="form-control" name="STR1">
              <option>ریال</option>
              <option>تومان</option>
            </select>
          </div>
        </div>
      </div>
      <h5><i className="far fa-shopping-bag"></i> همگام سازی با فروشگاه</h5>
      <div className="row mb-4">
        <div className="col-12 ">
          <div className="form-check">
            <input ref={triggerToShopRef}  name="trigger" type="checkbox" className="form-check-input" id="tigger" />
            <label  className=" form-check-label" htmlFor="tigger">&nbsp;همگام سازی با اطلاعات فروشگاه </label>
          </div>
        </div>
      </div>

      <div className="text-center">
        <input
          type="submit"
          value="ثبت"
          id="backsubmit"
          className="mt-5 btnCustom btnSubmit"
        />
      </div>
    </form>
  );
}
